export default "__VITE_ASSET__90acb2fe__"